import React from 'react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="py-16 px-6 bg-sage/5" data-id="element-173">
      <div className="max-w-3xl mx-auto text-center" data-id="element-174">
        <FadeIn data-id="element-175">
          <h2 className="text-3xl sm:text-4xl text-taupe mb-4" data-id="element-176">
            ¿Qué cambia en 7 días?
          </h2>
          <p className="text-xl text-taupe/70 italic mb-10" data-id="element-177">
            "No prometemos magia, prometemos biología."
          </p>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-6 mb-10" data-id="element-178">
          <FadeIn delay={0.2} data-id="element-179">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-sage/20" data-id="element-180">
              <div className="text-4xl sm:text-5xl font-serif text-amber mb-2" data-id="element-181">
                70%
              </div>
              <p className="text-lg text-taupe font-medium" data-id="element-182">
                menos llanto antes de dormir
              </p>
              <p className="text-sm text-taupe/60 mt-2" data-id="element-183">
                porque el bebé ya no llegará sobrecansado a la cuna.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-184">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-sage/20" data-id="element-185">
              <div className="text-4xl sm:text-5xl font-serif text-amber mb-2" data-id="element-186">
                Minutos
              </div>
              <p className="text-lg text-taupe font-medium" data-id="element-187">
                en lugar de horas
              </p>
              <p className="text-sm text-taupe/60 mt-2" data-id="element-188">
                al día 7, el tiempo que tardas en dormirlo se reducirá
                drásticamente.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}